module.exports = __webpack_public_path__ + "img/help-icon.ea4ca5e5.webp";